import _ from "lodash";

const updateObjectState = (stateObject, action, value) => {
  // Ensure stateObject is always an object, default to an empty object if null or undefined
  const currentState = stateObject || {};
  
  if (action === "whole") {
    // Completely replace the state object
    return value;
  }

  if (action === "update") {
    const updatedState = { ...currentState };

    // Separate overwriting fields and merging fields
    const { __overwrite, ...mergeFields } = value;

    // Explicitly overwrite specified fields
    if (__overwrite) {
      __overwrite.forEach((key) => {
        updatedState[key] = mergeFields[key]; // Overwrite or add the key
      });
    }

    // Merge remaining fields using Lodash
    return _.merge(updatedState, mergeFields);
  }

  if (action === "delete") {
    // Delete multiple keys provided in the value (value should be an array of keys to delete)
    const newState = { ...currentState };
    value.forEach((key) => {
      delete newState[key];
    });
    return newState;
  }

  return currentState;
};

const updateArrayState = (stateArray, action, value) => {
  // Ensure stateArray is always an array, default to an empty array if null or undefined
  const currentState = stateArray || [];

  if (action === "whole") {
    // Completely replace the array
    return value;
  }

  if (action === "update") {
    // Update existing shops or add new ones
    const updatedShops = currentState.map((shop) => {
      const updatedShop = value.find((newShop) => newShop.id === shop.id);
      return updatedShop ? { ...shop, ...updatedShop } : shop;
    });

    // Add any new shops that weren't in the existing state
    return [...updatedShops, ...value.filter((newShop) => !currentState.some((shop) => shop.id === newShop.id))];
  }

  if (action === "delete") {
    // Delete elements from the array (value should be an array of element's id to delete)
    return currentState.filter((item) => !value.includes(item.id));
  }

  return currentState;
};

export { updateObjectState, updateArrayState };
